// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__KAvDW","boxTitle":"Qualiphy_boxTitle__3Rr9u","box":"Qualiphy_box__7KpOr","toggleWrap":"Qualiphy_toggleWrap__3zNZW"};